<div class="items-view-controls d-flex align-items-center gap-2">
  <app-segmented-button
    ariaLabel="Item Scope"
    [options]="itemScopeOptions"
    [value]="itemScope()"
    (valueChange)="setItemScope($event)"
  ></app-segmented-button>

  <app-segmented-button
    ariaLabel="Item View"
    [options]="itemViewOptions"
    [value]="itemView()"
    (valueChange)="setItemView($event)"
  ></app-segmented-button>
</div>
